import React, { useState } from "react";
import useNumericInput from "../../hooks/useNumericInput";

function Login() {
  useNumericInput();

  const [formData, setFormData] = useState({
    mobile: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};

    // Mobile validation
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Please enter your mobile number.";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile.trim())) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Only allow numbers for mobile field
    if (name === "mobile") {
      if (!/^\d*$/.test(value)) return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;
    setLoading(true);

    sessionStorage.setItem("mobileNumber", formData.mobile.trim());

    setTimeout(() => {
      setLoading(false);
      window.location.href = "/verify-otp";
    }, 800);
  };

  return (
    <div className="main-wrapper">
      <div className="overflow-hidden p-3 acc-vh">
        <div className="row mt-5 w-100 g-0">
          <div className="col-lg-12 overflow-y-auto overflow-x-hidden">
            <div className="row">
              <div className="col-md-4 mx-auto">
                <form
                  method="post"
                  className="d-flex justify-content-between flex-column p-4 pb-0"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div>
                    <div className="mb-3">
                      <h3 className="mb-2">Login using Mobile Number</h3>
                      <p className="mb-0">
                        Enter your registered mobile number to receive a
                        One-Time Password (OTP) for login.
                      </p>
                    </div>

                    {/* Mobile Number Field */}
                    <div className="mb-3">
                      <label className="form-label">Mobile Number</label>
                      <div className="input-group input-group-flat">
                        <span className="input-group-text">
                          <i className="ti ti-phone" />
                        </span>
                        <input
                          type="text"
                          name="mobile"
                          className={`form-control only-numeric ${
                            errors.mobile ? "is-invalid" : ""
                          }`}
                          maxLength={10}
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.mobile && (
                        <div className="invalid-feedback d-block">
                          {errors.mobile}
                        </div>
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? "Sending..." : "Send OTP"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
